// extracted by mini-css-extract-plugin
module.exports = {"container":"WhereContent_container__4nsij","info":"WhereContent_info__dOZ_P","detailsLink":"WhereContent_detailsLink__U9mqx","disclaimer":"WhereContent_disclaimer__kmgDU"};